import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';

import { User } from 'models/user';
import { AuthService } from '../../core/auth.service';
import { JQ_TOKEN } from '../../core/jquery.service';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {
  user = new User();
  message: string;
  tempPassword: string;
  newPassword: string;
  gdprConsent = false;
  installerCompletedSignUp = false;

  constructor(
    public auth: AuthService,
    public router: Router,
    public route: ActivatedRoute,
    private toasterService: ToasterService,
    @Inject(JQ_TOKEN) private $: any
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.tempPassword = params.get('tempPassword');
      this.user.email = params.get('email');
    });
  }

  toggleGDPRBox() {
    this.gdprConsent = !this.gdprConsent;
  }

  onNewpassword() {
    console.log('The user is now ' + JSON.stringify(this.user));
    this.$('#loading-modal').modal();

    this.auth
      .newPassword(this.user, this.tempPassword, this.newPassword)
      .then(() => {
        this.$('#loading-modal').modal('hide');

        if (this.auth.isInstallerOnly()) {
          this.toasterService.pop('success', 'Success setting particulars', 'You can now login to the install app');
          this.installerCompletedSignUp = true;
        } else {
          this.toasterService.pop('success', 'Set user particulars');
          this.router.navigate(['/locations']);
        }
      })
      .catch(error => {
        this.$('#loading-modal').modal('hide');
        const message = error.message || `check user information or contact admin.`;
        this.message = `Try again, error: ${message}`;
      });
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/new-password/new-password.component.ts